import { MapfreButtonComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { ImpNoticeComponent } from '../../imp-notice/imp-notice.component';
import { MapfreLoadingComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/mapfre-loading/mapfre-loading.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule , DatePipe } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router , RouterModule } from '@angular/router';
import { Constants } from '@models/constants';
import { AutopayBillingService } from './../../../../../_services/my-insurance/autopay-billing.service';
import { PolicyDataService } from './../../../../../_services/data-services/policy-data.service';
import { AcmicService } from '@mapfre-design-library/src/public_api';
import { EnrollEftEpayService } from '@services/forms/enroll-eft-epay/enroll-eft-epay.service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreLoadingComponent, ImpNoticeComponent, MapfreButtonComponent],
  selector: 'app-payment-information-updated',
  templateUrl: './payment-information-updated.component.html',
  styleUrls: ['./payment-information-updated.component.scss'],
  providers: [DatePipe],
})
export class PaymentInformationUpdatedComponent implements OnInit {
  loading = true;
  impNoticeTxt: string;
  policyId: string;
  policy: any;
  sortedInvoices: any;
  isAcmic = false;
  constructor(
    private router: Router,
    private autopayBillingService: AutopayBillingService,
    private datePipe: DatePipe, private policyDataService: PolicyDataService,
    private activeRoute: ActivatedRoute,
    private acmicService: AcmicService,
    private eftService: EnrollEftEpayService
  ) {}

  ngOnInit(): void {
    this.isAcmic = this.acmicService.isACMIC();
    this.activeRoute.params.subscribe((params) => {
      this.policyId = params['policyid'];

      
      this.policyDataService.$policyDetails.subscribe((policyResponse) => {
        if (policyResponse && policyResponse.length) {
          this.policy = policyResponse.find(
            (response) =>
              response.policynumber.policyNumber === this.policyId
          );
          const impNoticeDetails = history.state.impNoticeDetails ?? {}
          if(this.policy){
            impNoticeDetails.policy = this.policy
          }
          this.impNoticeTxt = this.eftService.getImportantEditNotice(impNoticeDetails)?.impNotice;
          this.loading = false;
        }
      });
    });    
  }

  retrieveBillingInfo(){
    this.autopayBillingService
      .getWithdrawalData()
      .subscribe((withdrawalData) => {
        if (withdrawalData) {
          this.policyDataService.$policyDetails.subscribe((policyResponse) => {
            if (policyResponse && policyResponse.length) {
              this.policy = policyResponse.find(
                (response) =>
                  response.policynumber.policyNumber === this.policyId
              );
              if (
                this.policy &&
                this.policy.scheduleBills &&
                this.policy.scheduleBills.length
              ) {
                this.sortedInvoices = this.autopayBillingService.getSortedBills(
                  this.policy
                );
                if (this.isAcmic) {
                  this.impNoticeTxt = `Your withdrawal date change from the ${
                    withdrawalData.oldDeductionDay
                  } to the ${
                    withdrawalData.newDeductionDay
                  } of each month is being processed, your next payment will be processed on ${this.datePipe.transform(
                    this.sortedInvoices[0].dateDue,
                    Constants.DATE_MM_DD_YYYY
                  )}. `;
                } else {
                  this.impNoticeTxt = `Your withdrawal date change from the ${withdrawalData.oldDeductionDay}
                  to the ${withdrawalData.newDeductionDay} of each month is being processed, your next payment will be processed on`;
                }
              }
              this.loading = false;
            }
          });
        }
      });
  }
  openAutoPay(): void {
    this.router.navigate(['/billing', 'autopay']);
  }
}
